export default class CouponWelcome {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        welcomeCouponRetrieve(id: ${id}) {
          id
          totalPerUser
          active          
          coupon {
            id
            title
            deal {
              id
              name
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    response.data.data.welcomeCouponRetrieve.compressed = {
      coupon: response.data.data.welcomeCouponRetrieve.coupon   
    };  
    response.data.data.welcomeCouponRetrieve.deal = response.data.data.welcomeCouponRetrieve.coupon.deal.id;  
    response.data.data.welcomeCouponRetrieve.coupon = response.data.data.welcomeCouponRetrieve.coupon.id;

    return response.data.data.welcomeCouponRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query {
        welcomeCouponList {
          results {
            id
            coupon {
              id
              title
            }
            totalPerUser
            active
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.welcomeCouponList.results.reverse();
  }

  static async filter(axios, active) {
    const response = await axios.post(
      '/graphql/',
      `query{
        welcomeCouponList(active: ${active}) {
          results {
            id
            coupon {
              id
              title
            }
            totalPerUser
            active
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.welcomeCouponList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/', {
        query: `mutation deleteWelcomeCoupon($id: ID!) {
          deleteWelcomeCoupon(id: $id){
            ok
          }
        }`,
        variables: {
          "id": id
        }
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data.data.deleteWelcomeCoupon.ok;
  }

}